<template>
    <div>
        <button type="button" class="btn btn-default" title="Filters" v-on:click="getFilters(this)">
            <i class="fa fa-filter"></i>
            <span class="badge" style="background-color: #d9534f" :title="`${filterCount} Filter(s) Applied`" v-if="filterCount > 0">{{ filterCount }}</span>
        </button>

        <div style="z-index: 1; padding-top: 12px;" class="VueTables__dropdown-filter" v-if="showFilters">
            <div class="table-filters-padding" v-if="filtersLoaded">
                <slot v-bind:filterData="filterData" v-bind:filters="filters" v-bind:showMoreFilters="showMoreFilters"></slot>
                <hr />

                <div style="margin-top: 20px;">
                    <button type="button" class="btn btn-sm btn-default" v-on:click="closeFilters()">
                        <i class="fa fa-caret-up"></i> Close
                    </button>
                    <!--                    <button type="button" class="btn btn-sm btn-primary" v-on:click="open=true" title="Save the currently applied filters as reusable filter setting">
                            <i class="fa fa-save"></i> Save As
                        </button> -->
                    <button type="button" class="btn btn-sm btn-warning" v-on:click="clearFilters()">
                        <i class="fa fa-times"></i> Clear
                    </button>
                    <button type="button" class="btn btn-sm btn-success" v-on:click="applyFilters()">
                        <i class="fa fa-filter"></i> Apply
                    </button>
                </div>
            </div>
            <div v-else>
                <i class="fa fa-circle-o-notch fa-spin"></i>
            </div>
        </div>

        <modal v-model="open" title="Save Part Filters" ref="modal" id="modal-demo" size="lg" ok-text="Save Filter Configuration" ok-type="success">
            <div class="form-horizontal">
                <div class="form-group">
                    <label class="control-label col-md-3">Filter Name:</label>
                    <div class="col-md-7">
                        <input type="text" name="" class="form-control" placeholder="Enter a Name for this Filter Configuration" />
                    </div>
                </div>
                <div class="form-group">
                    <label class="control-label col-md-3">Global <i class="fa fa-question-circle" title="Global Filters can be used by all users."></i>:</label>
                    <div class="col-md-7">
                        <input type="checkbox" name="" />
                    </div>
                </div>
            </div>

            <template slot="footer">
                <button type="button" class="btn btn-sm btn-default" v-on:click="open = false">Cancel</button>
                <button type="button" class="btn btn-sm btn-success" v-on:click="saveFilter()">Save Filter Configuration</button>
            </template>

        </modal>
    </div>
</template>

<script>
export default {
    props: {
        filterUrl: {
            type: String,
            default: null,
        },

        filterKey: {
            type: String,
            required: true,
        },

        filters: {
            type: Object,
            required: true,
        },

        showMoreFilters: {
            type: Boolean,
            default: false,
        },

        emptyFilters: {
            type: Object,
            required: true,
        },
    },

    data: function() {
        return {
            urlFilters: {},
            filterData: {},
            //emptyFilters: null,
            filterCount: 0,
            filtersLoaded: false,
            showFilters: false,
            loading: false,
            open: false,
        }
    },

    watch: {
        filters(newValue, oldValue){
            //Update the count
            this.updateFilterCount();
        },

        appliedFilter(newVal, oldVal){
            //If null, clear filtes
            if(newVal == null)
            {
                this.clearFilters();
            }
        },
    },

    computed: {
        appliedFilter(){
            //Send it
            return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
        },
    },

    methods: {

        updateFilterCount() {
            //Reset the count
            this.filterCount = 0;
            var status = false;

            // Loop over objects in this.filters
            for (var obj in this.filters)
            {
                //Check if NULL or Empty
                if (this.filters[obj] === null || this.filters[obj] === '')
                {
                    //console.log('Value ('+obj+') is empty: ' + this.filters[obj]);
                    continue;
                }

                //Check if Array
                if (Array.isArray(this.filters[obj]))
                {
                    //Check IF there is a first value
                    if (this.filters[obj].length > 0 && this.filters[obj][0])
                    {
                        //Increment
                        this.filterCount++;
                    }

                    //Skip
                    continue;
                }

                //Check If Object
                else if (typeof this.filters[obj] === 'object' && obj === 'custom_fields')
                {
                    //Check Each
                    for(var custom_field_id in this.filters[obj])
                    {
                        //Check Each
                        if( this.filters[obj][custom_field_id] == null || this.filters[obj][custom_field_id] == '' || (Array.isArray(this.filters[obj][custom_field_id]) && this.filters[obj][custom_field_id].length === 0) )
                        {
                            continue;
                        }

                        //Increment
                        this.filterCount++;
                    }
                }

                //Check If Object
                else if (typeof this.filters[obj] === 'object')
                {
                    //Setup Empty
                    var empty = true;

                    //Check for Logic/Value inputs like Inspection Score.
                    if(this.filters[obj].hasOwnProperty('value') && !this.filters[obj].value)
                    {
                        continue;
                    }

                    //Check Each Property
                    for (var key in this.filters[obj])
                    {
                        //Check if the key exists
                        if (this.filters[obj].hasOwnProperty(key));
                        {
                            empty = false;
                        }
                    }

                    //If Not Empty, Increment
                    if (!empty)
                    {
                        //Increment the Count
                        this.filterCount++;
                    }

                    //Move on
                    continue;
                }

                else if (typeof this.filters[obj] === 'string' || typeof this.filters[obj] === 'number')
                {
                    this.filterCount++;
                }
            }
        },

        clearFilters() {
            //Clear the filters - Cannot Directly Mutate a Prop
            //this.filters = this.emptyFilters;

            //console.log(this.emptyFilters);
            //console.log(this.filters);

            //Loop and Reset ALL
            var keys = Object.keys(this.emptyFilters);

            //Loop and Handle EACH
            for (var i = 0; i < keys.length; i++)
            {
                //Set it
                this.filters[keys[i]] = this.emptyFilters[keys[i]];

                //Awlays make sure custom fields were reset
                //For some reason, the emptyFilters doesn't always clear it
                if(keys[i] === 'custom_fields')
                {
                    this.filters[keys[i]] = {};
                }
            }

            //Setup keys
            var keys = Object.keys(this.filters);

            //EHS-1348, Need to Clear Custom Form Filters
            for (var i = 0; i < keys.length; i++)
            {
                //Check key
                if(keys[i].indexOf('single_form_field_') !== -1)
                {
                    //Unset it
                    delete this.filters[keys[i]];
                }
            }

            //Reset to the Empty Filters Definition
            this.$store.commit('setFiltersAlt', {
                key: this.filterKey,
                filters: this.emptyFilters,
            });

            //Clear any saved filters
            this.$store.commit('setAppliedFilter', {key: this.filterKey, filter: null});

            //Update the count
            this.updateFilterCount();

            //Close it
            this.closeFilters();

            //Emit it
            this.$emit('filtersCleared', this.filters);
        },

        applyFilters() {
            //Set the store
            this.$store.commit('setFiltersAlt', {
                key: this.filterKey,
                filters: this.filters
            });

            //Update the count
            this.updateFilterCount();

            //Close it
            this.closeFilters();

            //Send it
            this.$emit('filtersChanged', this.filters);
        },

        setFilters(filters){
            //Loop and Reset ALL
            var keys = Object.keys(filters);

            //Loop and Handle EACH
            for (var i = 0; i < keys.length; i++)
            {
                //Set it
                this.filters[keys[i]] = filters[keys[i]];
            }

            // //Set the store
            // this.$store.commit('setFiltersAlt', {
            //     key: this.filterKey,
            //     filters: filters
            // });
            this.applyFilters();
        },

        extractFilters(rawFilters){
            //SEtup
            var formattedFilters = JSON.parse(JSON.stringify(rawFilters));
            var keys = Object.keys(formattedFilters);

            //Loop and Build
            for (var i = 0; i < keys.length; i++)
            {
                //setup
                var filterVal = rawFilters[keys[i]];

                //Check for Empty or Null
                if( (Array.isArray(filterVal) && filterVal.length == 0) || filterVal == null || filterVal == '')
                {
                    continue;
                }

                //Special Cases
                switch(keys[i])
                {
                    case 'inspection.JobsiteId':
                        //Extract the ID only
                        formattedFilters[keys[i]] = filterVal.hasOwnProperty('JobsiteId') ? filterVal.JobsiteId : null;
                        break;

                    case 'inspection.CreatedByUserId':
                        //Extract the ID only
                        formattedFilters[keys[i]] = filterVal.hasOwnProperty('UserId') ? filterVal.UserId : null;
                        break;

                    case 'inspection.status_id':
                    case 'inspection_observations.compliance_status_id':
                        //Extract the ID only
                        formattedFilters[keys[i]] = [];

                        //Loop and SEt
                        for (var j = 0; j < filterVal.length; j++)
                        {
                            formattedFilters[keys[i]].push(filterVal[j].id);
                        }
                        break;

                    default:
                        //Do nothing
                        break;
                }
            }

            //Send it
            return formattedFilters;
        },

        displayFilters(){
            //SEt it
            this.showFilters = true;
        },

        closeFilters() {
            //Hide the modal
            this.showFilters = false;
        },

        saveFilter() {
            //Send it
            this.$http
                .post('filters/save')
                .then(response => {
                    //Set the returned filter in the saved filters
                    this.savedFilters[response.data.table_filter_id] = response.data;
                });
        },

        setUrlFilters(filters){
            //Set it
            this.urlFilters = filters;
        },

        getFilters() {
            //Show the modal or container
            this.showFilters = this.showFilters === true ? false : true;

            //Check if the filters are already loaded or if the user is closing it
            if (this.filtersLoaded || this.showFilters === false || this.filterUrl == null)
            {
                //Make sure filters loading is true
                this.filtersLoaded = true;

                //Stop here
                return;
            }

            //Send it
            this.$http
                .get(this.filterUrl, this.urlFilters)
                .then(response => {
                    //Emit
                    //this.$emit('filterDataLoaded', response.data);
                    this.filterData = response.data;

                    //Set the flag
                    this.filtersLoaded = true;
                });
        },

        reset(){
            //Set the filter data
            this.clearFilters();

            //SEt the data
            this.filterData = {};
            this.filtersLoaded = false;
            this.showFilters = false;
        },

        resetColVis(tableComp){
            //Get ALL
            var visibleCols = tableComp.$children[0].allColumns;
            var columns = tableComp.columns;

            //Setup
            var hiddenCols = columns.filter(x => !visibleCols.includes(x));

            //Toggle Each
            for (var i = 0; i < hiddenCols.length; i++)
            {
                //Hide it - THIS ISN"T WORKING. FUNCTION DOES NOT EXIST
                tableComp.$children[0].toggleColumn(hiddenCols[i]);
            }
        },

        setColVis(tableComp){
            //Check if
            if(!this.appliedFilter)
            {
                return;
            }

            //Set the Filters
            //this.$store.state.tableFilters.filters.inspectionFilters = JSON.parse(this.$store.state.appliedFilter.table_filters);
            this.setFilters(JSON.parse(this.appliedFilter.table_filters));

            //SEtup
            var config = JSON.parse(this.appliedFilter.table_config);

            //Toggle the columns
            if(!config.visible_cols)
            {
                return;
            }

            //Get Hidden Columns
            var hiddenCols = config.columns.filter(x => !config.visible_cols.includes(x));

            //Toggle Each
            for (var i = 0; i < hiddenCols.length; i++)
            {
                //Hide it - THIS ISN"T WORKING. FUNCTION DOES NOT EXIST
                tableComp.$children[0].toggleColumn(hiddenCols[i]);
            }
        },

        setColVisFromSavedFilter(tableComponent, config){
            //Toggle the columns
            if(!config.visible_cols)
            {
                return;
            }

            //Get Hidden Columns
            var hiddenCols = config.columns.filter(x => !config.visible_cols.includes(x));

            //Toggle Each
            for (var i = 0; i < hiddenCols.length; i++)
            {
                //Hide it - THIS ISN"T WORKING. FUNCTION DOES NOT EXIST
                tableComponent.$children[0].toggleColumn(hiddenCols[i]);
            }
        },
    },

    mounted() {
        //Get the parts
        this.updateFilterCount();

        //Only set if null
        // if(this.emptyFilters === null)
        // {
        //     //Store the Empty Filter Definition
        //     this.emptyFilters = JSON.parse(JSON.stringify(this.filters));
        // }
    },
}
</script>